var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './DashboardCard.scss';
import GuestIcon from '@assets/svg/CuestIcon.svg';
import ChatsIcon from '@assets/svg/ChatsIconSystem.svg';
import PaymentIcon from '@assets/svg/PaymentIcon.svg';
import SumIcon from '@assets/svg/SumIcon.svg';
var DashboardCards = function (_a) {
    var total = _a.total, totalClients = _a.totalClients, todaysTotal = _a.todaysTotal, summary = _a.summary, _b = _a.variant, variant = _b === void 0 ? 'cash' : _b, labels = _a.labels;
    var isCoins = variant === 'coins';
    var suffix = isCoins ? ' монет' : '';
    var L = labels !== null && labels !== void 0 ? labels : {
        count: 'Всего гостей',
        period: isCoins ? 'Оплата чатов (эгокоины)' : 'Оплата чатов',
        daySlice: isCoins ? 'Оплата за день (монеты)' : 'Оплата за день',
        total: isCoins ? 'Общая сумма (монеты)' : 'Общая сумма',
    };
    var cards = [
        {
            title: L.count,
            value: "".concat(totalClients),
            icon: _jsx(GuestIcon, {}),
        },
        {
            title: L.period,
            value: isCoins ? "".concat(total !== null && total !== void 0 ? total : 0).concat(suffix) : "\u20BD ".concat(total),
            icon: _jsx(ChatsIcon, {}),
        },
        {
            title: L.daySlice,
            value: isCoins ? "".concat(todaysTotal !== null && todaysTotal !== void 0 ? todaysTotal : 0).concat(suffix) : "\u20BD ".concat(todaysTotal),
            icon: _jsx(PaymentIcon, {}),
        },
        {
            title: L.total,
            value: isCoins ? "".concat(summary !== null && summary !== void 0 ? summary : 0).concat(suffix) : "\u20BD ".concat(summary),
            icon: _jsx(SumIcon, {}),
        },
    ];
    return (_jsx("div", __assign({ className: "cards-container" }, { children: cards.map(function (card, index) { return (_jsxs("div", __assign({ className: "card" }, { children: [card.icon, _jsx("span", __assign({ className: "card-value" }, { children: card.value })), _jsx("span", __assign({ className: "card-title" }, { children: card.title }))] }), index)); }) })));
};
export default DashboardCards;
